// extracted by mini-css-extract-plugin
export default {"notification":"system-message_notification__pJoel","warning":"system-message_warning__oY9et"};